import { StrictMode } from "react";
import { HelmetProvider } from "react-helmet-async";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import "@/lib/fetch-429-toast";
import { routeTree } from "@/routeTree.gen";

const queryClient = new QueryClient();

const router = createRouter({ routeTree });

// register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// ensure light theme is default (remove dark class if present)
if (typeof document !== "undefined") {
  document.documentElement.classList.remove("dark");
}

// ssr is disabled for this page (see ../+config.ts) so this module only ever
// runs in the browser
export default function Page() {
  return (
    <StrictMode>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </HelmetProvider>
    </StrictMode>
  );
}
